// MOBILE MENU TOGGLE
const mobileMenuBtn = document.querySelector(".pf-menu-toggler");
const mobileMenuContainer = document.querySelector(".pf-action-navbar");

mobileMenuBtn.addEventListener("click", () => {
  mobileMenuContainer.classList.add("pf-active");
});

window.addEventListener("click", (e) => {
  if (
    !mobileMenuContainer.contains(e.target) &&
    !mobileMenuBtn.contains(e.target)
  ) {
    mobileMenuContainer.classList.remove("pf-active");
  }
});

// MOBILE SUBMENU TOGGLE
mobileMenuContainer.addEventListener("click", (e) => {
  const target = e.target.closest(".pf-navbar-link");
  if (!target) return;

  const parent = target.parentElement;
  if (!parent.classList.contains("has-submenu")) return;

  e.preventDefault();

  const activeItem = document.querySelector(".pf-navbar-item.pf-active");

  if (activeItem) {
    activeItem.classList.remove("pf-active");
  }

  parent.classList.add("pf-active");
});

// Search Bar Show/Hide
const searchBtn = document.querySelector(".pf-search-btn");
const searchContainer = document.querySelector(".pf-header-search");

searchBtn.addEventListener("click", () => {
  searchBtn.classList.toggle("pf-active");
  searchContainer.classList.toggle("pf-active");
});

// mini cart popup
const cartBtn = document.querySelector(".pf-header .pf-action-cart");
const cartNotification = document.querySelector(".pf-header .pf-action-cart .pf-mini-cart-container");

const miniCartContainer = $('.pf-header .pf-action-cart .pf-mini-cart-container');
const miniCartLoader = '#pf-mini-cart-loader';

let isHovered = false; // lock flag

const loadMiniCart = () => {
  miniCartContainer.load(`${location.href} ${miniCartLoader}`);
};

cartBtn.addEventListener("mouseenter", () => {
  if (!isHovered) {
    isHovered = true;
    loadMiniCart();
    cartNotification.classList.add("active");
  }
});

cartBtn.addEventListener("mouseleave", () => {
  if (isHovered) {
    isHovered = false;
    loadMiniCart();
    cartNotification.classList.remove("active");
  }
});





